import { styled } from '@acko-tech/building-blocks.ui.common';

export const PaginationRow = styled.div`
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 8px;
    width: 100%;

    @media screen and (max-width: 768px) {
        justify-content: center;
        margin-top: 20px;
        padding-bottom: 8px;
    }
`;

export const PaginationMeta = styled.span`
    color: #6e6e6e;
    font-size: 14px;
    margin-right: 8px;
`;

export const PageButton = styled.button<{ isActive: boolean }>`
    min-width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid ${({ isActive }) => (isActive ? '#5d4aa8' : '#d6d6d6')};
    background: ${({ isActive }) => (isActive ? '#ffffff' : 'transparent')};
    color: #2f2e38;
    font-size: 14px;
    font-weight: ${({ isActive }) => (isActive ? 600 : 400)};
    cursor: pointer;
`;

export const PaginationArrow = styled.button<{ disabled?: boolean }>`
    min-width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #d6d6d6;
    background: #ffffff;
    color: #2f2e38;
    font-size: 14px;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const PaginationDots = styled.span`
    color: #6e6e6e;
    font-size: 14px;
    padding: 0 2px;
`;
